<template>
  <v-navigation-drawer
    v-model="drawer"
    :mini-variant.sync="mini"
    :stateless="true"
  >
    <v-list dense nav v-if="UserRole == 'HubAdmin'" expand>
      <v-list-item class="pt-6" link>
        <v-list-item-icon>
          <v-icon color="#6b2c2c">mdi-view-dashboard</v-icon>
        </v-list-item-icon>

        <v-list-item-content @click="menuActionClick('/dashboard')" id="Content-Dashbaord">
          <v-list-item-title id="title-Dashbaord" style="color: #6b2c2c">Dashboard</v-list-item-title>
        </v-list-item-content>


        <v-btn icon @click.stop="mini = !mini">
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
      </v-list-item>

      <v-template v-for="item in items" :key="item.title">
        <v-list-item
          link
          v-if="
            item.childrens == undefined ||
              item.childrens == null ||
              item.childrens.length == 0
          "
        >
          <v-list-item-icon>
            <v-icon style="color: #6b2c2c">{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content @click="menuActionClick(item.url)" :id="'content-' + item.id">
            <v-list-item-title style="color: #6b2c2c" :id="'title-' + item.id" @click="menuActionClick(item.url)">{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-group v-else no-action color="#6b2c2c">
          <!-- LEVEL 1 -->
          <template v-slot:activator>
            <v-list-item-icon>
              <v-icon color="#6b2c2c">{{ item.icon }}</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title style="color:#6b2c2c">
                {{ item.title }}
              </v-list-item-title>
            </v-list-item-content>
          </template>

          <!-- LEVEL 2: childrens -->
          <v-list-item
            class="pl-6"
            v-for="child in item.childrens"
            :key="child.id"
            link
            @click="menuActionClick(child.url)"
          >
            <v-list-item-icon>
              <v-icon color="#6b2c2c">{{ child.icon }}</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title style="color:#6b2c2c">
                {{ child.title }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <!-- LEVEL 2: subChildren (Expandable again) -->
          <v-list-group
            v-for="sub in item.subChildren"
            :key="sub.id"
            no-action
            class="pl-4"
            color="#6b2c2c"
          >
            <!-- LEVEL 2 HEADER -->
            <template v-slot:activator style="color: #6b2c2c;">
              <v-list-item-icon>
                <v-icon color="#6b2c2c">{{ sub.icon }}</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title style="color:#6b2c2c">
                  {{ sub.title }}
                </v-list-item-title>
              </v-list-item-content>
            </template>

            <!-- LEVEL 3: sub.items -->
            <v-list-item
              v-for="subItem in sub.items"
              :key="subItem.id"
              link
              class="pl-8"
              @click="menuActionClick(subItem.url)"
            >
              <v-list-item-icon>
                <v-icon color="#6b2c2c">{{ subItem.icon }}</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title style="color:#6b2c2c">
                  {{ subItem.title }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
        </v-list-group>

        
      </v-template>
      <!--
      <v-list-item class="pt-0" link>
        <v-list-item-icon>
          <v-icon>mdi-link-box</v-icon>
        </v-list-item-icon>

        <v-list-item-content @click="openExternalUrl('https://subscriptions.zoho.com');" id="Content-Subscriptions">
          <v-list-item-title id="title-subscriptions">Subscriptions</v-list-item-title>
        </v-list-item-content>
      </v-list-item>-->
    </v-list>

    <!--Organizations Menu v-if="IsOrgLogin"-->

    <v-list dense nav v-if="UserRole == 'PortalAdmin'">
      <v-list-item class="pt-6" link>
        <v-list-item-icon>
          <v-icon>mdi-view-dashboard</v-icon>
        </v-list-item-icon>

        <v-list-item-content
          @click="menuActionClick('/organization/dashboard')" id="dashbaord">
          <v-list-item-title>Dashboard</v-list-item-title>
        </v-list-item-content>

        <v-btn icon @click.stop="mini = !mini">
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
      </v-list-item>
    </v-list>

    <v-treeview hoverable :items="orgMenuItems" v-if="IsOrgLogin">
      <template slot="label" slot-scope="{ item }">
        <div v-if="!item.children">
          <a @click="menuOrgActionClick(item)" class="menuItemChildren" :id="'a-' + item.id">
            <v-icon v-if="!item.children"> {{ item.icon }} </v-icon>
            {{ item.name }}
          </a>
        </div>
        <div v-if="item.children" class="menuItemPerent">
          {{ item.name }}
        </div>
      </template>
    </v-treeview>
    <!--End Organizations Menu -->

    <!--Publisher Menu -->
    <v-list dense nav v-if="UserRole == 'Publisher'">
      <v-list-item class="pt-6" link>
        <v-list-item-icon>
          <v-icon>mdi-view-dashboard</v-icon>
        </v-list-item-icon>

        <v-list-item-content @click="menuActionClick('/publisher/dashboard')" id="dashbaord1">
          <v-list-item-title>Dashboard</v-list-item-title>
        </v-list-item-content>

        <v-btn icon @click.stop="mini = !mini">
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
      </v-list-item>

      <v-list-item v-for="item in pubMenuItems" :key="item.title" link>
        <v-list-item-icon>
          <v-icon>{{ item.icon }}</v-icon>
        </v-list-item-icon>
        <v-list-item-content @click="menuActionClick(item.url)" :id="'content-' + item.id">
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <!--End publisher Menu -->
  </v-navigation-drawer>
</template>

<script>
import { mapState, mapGetter, mapActions } from "vuex";
export default {
  name: "LeftMenu",
  created() {},
  methods: {
    ...mapActions(["getLeftMenuCollapse"]),
    ...mapActions(["getLogin"]),
    menuActionClick(action) {
      if (this.$route.path != action) this.$router.push(action);
    },
    menuOrgActionClick(item) {
      if (item.url != undefined)
        if (this.$route.path != item.url) this.$router.push(item.url);
    },
    openExternalUrl(url)
    {
      window.open(url);
    }
  },
  computed: {
    ...mapState({ IsOrgLogin: "IsOrgLogin" }),
    ...mapState({ UserRole: "UserRole" }),
    //...mapState({ IsLogin: "IsLogin" }),

    ...mapState({ drawer: "getLogin" })
  },
  watch: {
    mini: function(val) {
      this.getLeftMenuCollapse(val);
    },
    getLogin: function(val) {
      // console.log(' getLogin ' + val )
      // this.drawer = val
    }
  },
  data() {
    return {
      drawer: true,
      mini: false,
      items: [
        //{ title: "Dashboard", icon: "mdi-view-dashboard", url: "/dashboard" },
        //{ title: "Author", icon: "mdi-book", url: "/author" },
        {
          title: "Subscriptions",
          icon: "mdi-cart",
          url: "",
          id:"Subscriptions",
          childrens: [
            {
              title: "Organizations",
              icon: "mdi-database",
              url: "/organization",
              id:"Subscriptions-Organization"
            },
            {
              title: "Individuals",
              icon: "mdi-database",
              url: "/individuals",
              id: "Subscriptions-Individuals"
            }
          ]
        },
        {
          title: "eBooks ",
          icon: "mdi-book",
          url: "",
          id:"ContentLibrary",
          childrens: [
            {
              title: "Books",
              icon: "mdi-book",
              url: "/publications",
              id:"Publications"
            },
            {
              title: "Collections",
              icon: "mdi-database",
              url: "/collection",
              id:"eBooks-Collections"
            },
            // {
            //   title: "Journals",
            //   icon: "mdi-book",
            //   url: "/journal",
            //   id:"Journals"
            // },
            {
              title: "Ingestion",
              icon: "mdi-import",
              url: "/import",
              id: "import"
            },
            {
              title: "Publishers",
              icon: "mdi-database",
              url: "/publisher",
              id: "eBooks-Publishers"
            },
            // {
            //   title: "Publishers",
            //   icon: "mdi-database",
            //   url: "/publisher",
            //   id: "eBooks-Publishers"
            // },
            // { 
            //   title: "Borrowing History", 
            //   icon: "mdi-book", 
            //   url: "/lending" ,
            //   id:"Publications-Reporting" },
          ]
        },
        // {
        //   title: "Journals",
        //   icon: "mdi-book",
        //   url: "/journal",
        //   id:"Publications",
        //   childrens: [
        //     {
        //       title: "Collections",
        //       icon: "mdi-database",
        //       url: "/journal-collection",
        //       id:"Journals-Collections"
        //     },
        //     {
        //       title: "Institutions",
        //       icon: "mdi-database",
        //       url: "/institutions",
        //       id: "Journals-Institutions"
        //     }
        //   ]
        // },
        // {
        //   title: "Publications",
        //   icon: "mdi-book",
        //   url: "/publications",
        //   id:"Publications",
        //   childrens: [
        //     {
        //       title: "Books",
        //       icon: "mdi-database",
        //       url: "/publications",
        //       id:"Publications-Data"
        //     },
        //     {
        //       title: "Journals",
        //       icon: "mdi-book",
        //       url: "/journal",
        //       id:"Journals"
        //     },

            
        //     // {
        //     //   title: "Reporting",
        //     //   icon: "mdi-library-books",
        //     //   url: "/collection"
        //     // },
        //   ]
        // },
        // { title: "OA Publications", icon: "mdi-book", url: "/oaPublications", id:"OpenAccessPublications" },
        // {
        //   title: "Fulfillment",
        //   icon: "mdi-cart",
        //   url: "/fulfillmentcollections",
        //   id:"Fulfillment",
        //   childrens: [
        //     {
        //       title: "eBooks",
        //       icon: "mdi-database",
        //       url: "/purchase",
        //       id:"Fulfillment-eBooks"
        //     },
        //     {
        //       title: "Collections",
        //       icon: "mdi-database",
        //       url: "/fulfillmentcollections",
        //       id: "Fulfillment-Collections"
        //     }
        //   ]
        // },
        // {
        //   title: "Collections",
        //   icon: "mdi-cart",
        //   url: "/collection",
        //   id:"collections",
        //   childrens: [ 
        //   { title: "Publications", icon: "mdi-library-books", url: "/collection", id:"Collections" },
        //   { title: "Journals", icon: "mdi-library-books", url: "/journal-collection" },
        //   ]
        // },
        // { title: "Users", icon: "mdi-account", url: "/user", id: "user" },
        //{ title: "Groups", icon: "mdi-account-multiple", url: "/usergroup" },
        // {
        //   title: "Organizations",
        //   icon: "mdi-account-group",
        //   url: "/organization",
        //   id: "Organizations"
        // },
        // {
        //   title: "User Subscriptions",
        //   icon: "mdi-book-plus",
        //   url: "/subscription"
        // },
        //{ title: "Group Subscriptions", icon: "mdi-book-plus-multiple", url: "/groupSubscription"},
        //{ title: "Licenses", icon: "mdi-license", url: "/licenses" },
        // { title: "Ingestion", icon: "mdi-import", url: "/import", id: "import" },
        // { title: "Logs", icon: "mdi-file-replace-outline", url: "/userlogs", id:"Logs" },
        {
          title: "Journals",
          icon: "mdi-book",
          childrens: [
            // {
            //   title: "Publishers",
            //   icon: "mdi-database",
            //   url: "/publisher",
            //   id: "eBooks-Publishers"
            // },
            {
              title: "Journals",
              icon: "mdi-book",
              url: "/journal",
              id:"Journals"
            },
            {
              title: "Journal Providers",
              icon: "mdi-database",
              url: "/institutions",
              id: "Journals-Institutions"
            }
          ]
        },
        {
          title: "Administration",
          icon: "mdi-account",
          childrens: [
            { title: "Admin Users", icon: "mdi-account", url: "/user", id: "user" },
            { title: "LTI Platform", icon: "mdi-account", url: "/ltiplatform", id: "lti-platform" },
          ],
          subChildren: [
            { title: "Reports", icon: "mdi-chart-bar", url: "" , id:"Reports", 
            items: [
              { title: "User Logs", icon: "mdi-file-replace-outline", url: "/userlogs", id:"Logs" },
              { title: "Borrowing History", icon: "mdi-book", url: "/lending" , id:"Publications-Reporting" },
              { title: "Version History", icon: "mdi-history", url: "/appversions" , id:"App-Versions" }
            ]
            }
          ]
        }
        // { title: "External Links", icon: "mdi-link-box", url: "/ExternalLinks", id:"ExternalLinks" },
        //{ title: "User Request", icon: "mdi-license", url: "/user-request" },
        // { title: "Purchase", icon: "mdi-library-books", url: "/orgpurchasepublication" },
        // { title: "Lending", icon: "mdi-book", url: "/lending" },
      ],
      orgItems: [
        {
          title: "Publications",
          icon: "mdi-book",
          url: "/organization/publications",
          id:"Publications"
        },
        {
          title: "My Books",
          icon: "mdi-book",
          url: "/organization/mypublications",
          id:"MyPublications"
        },
        {
          title: "My Journals",
          icon: "mdi-book",
          url: "/organization/myjournals",
          id:"myJournals"
        },
        { title: "Users", icon: "mdi-account", url: "/organization/users" ,id:"Users" },
        {
          title: "Groups",
          icon: "mdi-account-multiple",
          url: "/organization/OrgUserGroups",
          id:"Groups"
        },
        {
          title: "Collections",
          icon: "mdi-library-books",
          url: "/organization/collections",
          id:"Collections"
        },
        {
          title: "My Collections",
          icon: "mdi-library-books",
          url: "/organization/mycollection",
          id:"MyCollections"
        },
        {
          title: "Group Subscription",
          icon: "mdi-book-plus",
          url: "/organization/groupSubscription",
          id:"GroupSubscription"
        },
        {
          title: "Licenses",
          icon: "mdi-license",
          url: "/organization/licenses",
          id:"Licenses"
        }
      ],
      orgMenuItems: [
        // {
        //   id: 1,
        //   name: "Publications",
        //   id:"Publications",
        //   children: [
        //     /*{
        //       id: 2,
        //       name: "Publications",
        //       icon: "mdi-book",
        //       url: "/organization/publications",
        //     },*/
        //     {
        //       id: 3,
        //       name: "My Books",
        //       icon: "mdi-book",
        //       url: "/organization/mypublications",
        //       id:"Publications-MyPublications"
        //     },
        //     {
        //       id: 4,
        //       name: "My Journal",
        //       icon: "mdi-book",
        //       url: "/organization/myjournals",
        //       id:"journals-myjournals"
        //     }
        //   ]
        // },
        {
          id: 4,
          name: "User Management",
          id:"UserManagement",
          children: [
            {
              id: 5,
              name: "Users",
              icon: "mdi-account",
              url: "/organization/users"
            },
            {
              id: 6,
              name: "Groups",
              icon: "mdi-account-multiple",
              url: "/organization/OrgUserGroups"
            },
            // {
            //   id: 7,
            //   name: "User Subscriptions",
            //   icon: "mdi-book-plus",
            //   url: "/organization/user-subscription"
            // },
            // {
            //   id: 10,
            //   name: "Subscriptions",
            //   icon: "mdi-book-plus-multiple",
            //   url: "/organization/groupSubscription"
            // },
            // {
            //   id: 15,
            //   name: "Collection Assignment",
            //   icon: "mdi-account-multiple",
            //   url: "/organization/OrgCollectionGroup"
            // },
          ]
        },
        {
          id: 1,
          name: "Collections",
          children: [
            {
              id: 2,
              name: "Subscribed Colls",
              icon: "mdi-library-books",
              url: "/organization/collections",
              id:"Collections"
            },
            // {
            //   id: 3,
            //   name: "My Collections",
            //   icon: "mdi-library-books",
            //   url: "/organization/mycollection"
            // },
            {
              id: 4,
              name: "Custom Book Colls",
              icon: "mdi-library-books",
              url: "/organization/OrgCollectionNew",
              id:"OrgCollections"
            },
            {
              id: 5,
              name: "Custom journal Colls",
              icon: "mdi-library-books",
              url: "/organization/OrgJournalCollection",
              id:"OrgJournalCollection"
            }
          ]
        },
        /*
        {
          id: 8,
          name: "Licenses",
          children: [
            {
              id: 9,
              name: "Licenses",
              icon: "mdi-license",
              url: "/organization/licenses"
            }
          ]
        },*/
        {
          id: 9,
          name: "Reports",
          children: [
            {
              id: 9,
              name: "User Logs",
              icon: "mdi-file-replace-outline",
              url: "/organization/logs"
            },
            {
              id: 10,
              name: "Borrowing History",
              icon: "mdi-book",
              url: "/lending" , 
              id:"Publications-Reporting"
            }
          ]
        }
      ],
      pubMenuItems: [
        {
          title: "Publications",
          icon: "mdi-book",
          url: "/publisher/publications",
          id:"Publications"
        }
      ]
    };
  }
};
</script>
<style scoped>
.v-list-item__icon {
  margin-right: 10px !important;
}
.menuItemChildren {
  color: rgba(0, 0, 0, 0.87);
  font-size: 0.8125rem;
  font-weight: 500;
  line-height: 1rem;
}
.menuItemPerent {
  margin-left: 0px;
  color: rgba(0, 0, 0, 0.87);
  font-size: 0.8125rem;
  font-weight: 500;
  line-height: 1rem;
  margin-left: 0px;
}
.v-list-item {
}
</style>



// WEBPACK FOOTER //
// src/components/LeftMenu.vue